import React, { memo } from 'react';
import { useTranslation } from 'react-i18next';

import { Paper } from '../../material-ui/Paper';
import { Tooltip } from '../../material-ui/Tooltip';
import { DutyTimeCounter } from '../../DutyTimeCounter/DutyTimeCounter';
import { TOOLTIP_ENTER_TOUCH_DELAY, TOOLTIP_LEAVE_TOUCH_DELAY } from '../../../service/constants';
import { useDutyTimePanel } from './useDutyTimePanel';
import { useStyles } from './useStyles';

export const DutyTimePanel = memo(() => {
    const { isDutyTime, currentLeg } = useDutyTimePanel();

    const { t: translate } = useTranslation();
    const classes = useStyles();

    const dutyTimeTitle = isDutyTime ? 'labels.curDuteTime' : 'labels.duteTimeNotStart';

    return (
        <Paper className={classes.paper} elevation={0}>
            {currentLeg ? (
                <Tooltip
                    enterTouchDelay={TOOLTIP_ENTER_TOUCH_DELAY}
                    leaveTouchDelay={TOOLTIP_LEAVE_TOUCH_DELAY}
                    placement="top"
                    title={translate(dutyTimeTitle)}
                >
                    <div>
                        <DutyTimeCounter showLabel={false} />
                    </div>
                </Tooltip>
            ) : (
                ''
            )}
        </Paper>
    );
});

DutyTimePanel.displayName = 'DutyTimePanel';
